import { Button } from "@/components/ui/button";
import { NavLink } from "react-router-dom";

const NotFoundPage = () => {
  return (
    <>
      <div className="flex flex-col items-center justify-center h-full">
        <div className="flex flex-col items-center p-10 bg-transparent rounded-md shadow-xl backdrop-blur-3xl">
          <p className="font-bold">404</p>
          <p>The page you reached does not exists</p>
          <NavLink to="/">
            <Button>Return home</Button>
          </NavLink>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
